import axios from 'axios';
import firebaseService from './firebase.service';

// Create axios instance with default config
const apiClient = axios.create({
	baseURL: process.env.REACT_APP_SERVER,
	timeout: 30000,
	headers: {
		'Content-Type': 'application/json'
	}
});

// Request interceptor - add auth token to all requests
apiClient.interceptors.request.use(
	async (config) => {
		try {
			const user = firebaseService.auth.currentUser;
			if (user) {
				const token = await user.getIdToken(true);
				config.headers.authorization = `Bearer ${token}`;
			}
			return config;
		} catch (error) {
			console.error('Error getting auth token:', error);
			return Promise.reject(error);
		}
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Response interceptor - handle common errors
apiClient.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (error.response) {
			// Handle specific error codes
			switch (error.response.status) {
				case 401:
					// Unauthorized - token might be expired
					console.error('Unauthorized - please sign in again');
					// Could trigger a logout here
					break;
				case 403:
					console.error('Forbidden - insufficient permissions');
					break;
				case 404:
					console.error('Resource not found');
					break;
				case 500:
					console.error('Server error - please try again later');
					break;
				default:
					console.error('API Error:', error.response.data?.message || error.message);
			}
		} else if (error.request) {
			console.error('Network error - please check your connection');
		} else {
			console.error('Request error:', error.message);
		}
		return Promise.reject(error);
	}
);

// API service methods
const apiService = {
	// Messages API
	messages: {
		getAll: (params) => apiClient.get('/api/messages', { params }),
		getById: (id) => apiClient.get(`/api/messages/${id}`),
		getDailyStats: (params) => apiClient.get('/api/messages/daily', { params }),
		getHourlyStats: (params) => apiClient.get('/api/messages/hourly', { params }),
		getStatusStats: (params) => apiClient.get('/api/messages/status', { params })
	},

	// Broadcasts API
	broadcasts: {
		getAll: (params) => apiClient.get('/api/broadcasts', { params }),
		getById: (id) => apiClient.get(`/api/broadcasts/${id}`),
		create: (data) => apiClient.post('/api/broadcasts', data),
		update: (id, data) => apiClient.put(`/api/broadcasts/${id}`, data),
		delete: (id) => apiClient.delete(`/api/broadcasts/${id}`),
		getStatusStats: (params) => apiClient.get('/api/broadcasts/status', { params })
	},

	// Messaging Services API
	messagingServices: {
		getAll: () => apiClient.get('/api/messaging-services')
	},

	// HubSpot API
	hubspot: {
		getLists: () => apiClient.get('/api/hubspot/lists')
	}
};

export { apiClient };
export default apiService;
